/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { isAuthorized } from "../../helpers/AuthUtils";
// import DocumentTypeList from "./DocumentTypeList";
// import QualificationTypeList from "./QualificationTypeList";
// import QualificationNameList from "./QualificationNameList";
// import QualificationSubjectList from "./QualificationSubjectList";
// import UniversityList from "./UniversityList";
import DistrictList from '../masterManagement/components/DistrictList';
import ExamSubjectList from '../masterManagement/components/ExamSubjectList';
import StageList from '../masterManagement/components/StageList';
import StatesList from '../masterManagement/components/StatesList';
import TehsilList from '../masterManagement/components/TehsilList';
import VillageList from '../masterManagement/components/VillageList';
// import LookupOptionList from "./LookupOptionList";
// import RequisitionDepartmentList from './RequisitionDepartmentList';
// import RequisitionSpecialisationList from "./RequisitionSpecialisationList";
// import InstitutionList  from './InstitutionList';
// import RequisitionPostList from "./RequisitionPostList";
import DocumentTypeList from '../masterManagement/components/DocumentTypeList';
import LookupOptionList from '../masterManagement/components/LookupOptionList';
import QualificationNameList from '../masterManagement/components/QualificationNameList';
import QualificationSubjectList from '../masterManagement/components/QualificationSubjectList';
import QualificationTypeList from '../masterManagement/components/QualificationTypeList';
import UniversityList from '../masterManagement/components/UniversityList';
import "../styles/master_management.css";
import commonEnLabels from '../../common/labels/common_en.json';

let headerMenuNamesCaption = ['Document Type', 'Qualification Type', 'Qualification Name', 'Subject', 'University', 'Lookup Option', 'States', 'Districts', 'Tahsil', 'Village', 'Exam Subjects', 'Stage'];
let headerMenuNamesComponent = ['DocumentTypeList', 'QualificationTypeList', 'QualificationNameList', 'QualificationSubjectList', 'UniversityList', 'LookupOptionList', 'StatesList', 'DistrictList', 'TehsilList', 'VillageList', 'ExamSubjectList', 'StageList',];
let headerField = [];
headerMenuNamesCaption.forEach((element, index) => {
    let componentName = headerMenuNamesComponent[index];
    headerField[index] = { "id": index, "steps": "Step " + index, "name": element, "componentName": componentName };
});


const MasterManagement = (props) => {
    const [stepName, setName] = useState(headerField[0].componentName);
    const { authData } = useSelector(state => state.loginReducer, shallowEqual);
    let deptRoles = authData && authData.deptRoles && authData.deptRoles[0] && authData.deptRoles[0].roleId;
    const hasCreateMasterPermission = (deptRoles === commonEnLabels.DATABASE_VALUES.SUPER_ADMIN_ROLE_ID) ? true :  isAuthorized(authData, null, "MASTER_MGMT", "C");
    const hasReadMasterPermission = (deptRoles === commonEnLabels.DATABASE_VALUES.SUPER_ADMIN_ROLE_ID) ? true :  isAuthorized(authData, null, "MASTER_MGMT", "R");
    const hasUpdateMasterPermission = (deptRoles === commonEnLabels.DATABASE_VALUES.SUPER_ADMIN_ROLE_ID) ? true :  isAuthorized(authData, null, "MASTER_MGMT", "U");
    const hasDeletMasterPermission = (deptRoles === commonEnLabels.DATABASE_VALUES.SUPER_ADMIN_ROLE_ID) ? true :  isAuthorized(authData, null, "MASTER_MGMT", "D");
    
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])
    
    return (
        authData &&
        <div className="px-2">
            { (hasCreateMasterPermission || hasReadMasterPermission || hasUpdateMasterPermission || hasDeletMasterPermission) == true ?
             <> 
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                    {headerField && headerField.map((element, index) =>
                        <li className="nav-item" key={element.id} role="button" >
                            <a className={stepName === element.componentName ? "nav-link active" : "nav-link bg-profile-tabs"} value="home" id="home-tab" onClick={() => { setName(element.componentName); }} data-toggle="tab" role="tab" aria-controls="home" aria-selected="false">
                                <span>{element.name}</span>
                            </a>
                        </li>
                    )}
                </ul>
                <div className="tab-content border border-light" id="myTabContent">
                    {stepName === "DocumentTypeList" && <div className={stepName === "DocumentTypeList" ? "tabContent-inner tab-pane fade show active" : "tabContent-inner tab-pane fade"} id="profile" role="tabpanel" aria-labelledby="profile-tab" >
                        <DocumentTypeList />
                    </div>}
                    {stepName === "QualificationTypeList" && <div className={stepName === "QualificationTypeList" ? "tabContent-inner tab-pane fade show active" : "tabContent-inner tab-pane fade"} id="profile" role="tabpanel" aria-labelledby="profile-tab" >
                        <QualificationTypeList />
                    </div>}
                    {stepName === "QualificationNameList" && <div className={stepName === "QualificationNameList" ? "tabContent-inner tab-pane fade show active" : "tabContent-inner tab-pane fade"} id="profile" role="tabpanel" aria-labelledby="profile-tab" >
                        <QualificationNameList />
                    </div>}
                    {stepName === "QualificationSubjectList" && <div className={stepName === "QualificationSubjectList" ? "tabContent-inner tab-pane fade show active" : "tabContent-inner tab-pane fade"} id="profile" role="tabpanel" aria-labelledby="profile-tab" >
                        <QualificationSubjectList />
                    </div>}
                    {stepName === "LookupOptionList" && <div className={stepName === "LookupOptionList" ? "tabContent-inner tab-pane fade show active" : "tabContent-inner tab-pane fade"} id="profile" role="tabpanel" aria-labelledby="profile-tab" >
                        <LookupOptionList />
                    </div>}
                    {stepName === "UniversityList" && <div className={stepName === "UniversityList" ? "tabContent-inner tab-pane fade show active" : "tabContent-inner tab-pane fade"} id="profile" role="tabpanel" aria-labelledby="profile-tab" >
                        <UniversityList />
                    </div>}
                    {stepName === 'StatesList' && <div className={stepName === "StatesList" ? "tabContent-inner tab-pane fade show active" : "tabContent-inner tab-pane fade"} id="profile" role="tabpanel" aria-labelledby="profile-tab" >
                        <StatesList />
                    </div>}
                    {stepName === "DistrictList" && <div className={stepName === "DistrictList" ? "tabContent-inner tab-pane fade show active" : "tabContent-inner tab-pane fade"} id="profile" role="tabpanel" aria-labelledby="profile-tab" >
                        <DistrictList />
                    </div>}
                    {stepName === "TehsilList" && <div className={stepName === "TehsilList" ? "tabContent-inner tab-pane fade show active" : "tabContent-inner tab-pane fade"} id="profile" role="tabpanel" aria-labelledby="profile-tab" >
                        <TehsilList />
                    </div>}
                    {stepName === "VillageList" && <div className={stepName === "VillageList" ? "tabContent-inner tab-pane fade show active" : "tabContent-inner tab-pane fade"} id="profile" role="tabpanel" aria-labelledby="profile-tab" >
                        <VillageList />
                    </div>}
                    {stepName === "ExamSubjectList" && <div className={stepName === "ExamSubjectList" ? "tabContent-inner tab-pane fade show active" : "tabContent-inner tab-pane fade"} id="profile" role="tabpanel" aria-labelledby="profile-tab" >
                        <ExamSubjectList />
                    </div>}
                    {stepName === "StageList" && <div className={stepName === "StageList" ? "tabContent-inner tab-pane fade show active" : "tabContent-inner tab-pane fade"} id="profile" role="tabpanel" aria-labelledby="profile-tab" >
                        <StageList />
                    </div>}
                    {/* <div className={stepName === "RequisitionDepartmentList" ? "tabContent-inner tab-pane fade show active" : "tabContent-inner tab-pane fade"} id="profile" role="tabpanel" aria-labelledby="profile-tab" >
                        <RequisitionDepartmentList/>
                    </div>
                    <div className={stepName === "InstitutionList" ? "tabContent-inner tab-pane fade show active" : "tabContent-inner tab-pane fade"} id="profile" role="tabpanel" aria-labelledby="profile-tab" >
                        <InstitutionList/>
                    </div>
                    <div className={stepName === "RequisitionSpecialisationList" ? "tabContent-inner tab-pane fade show active" : "tabContent-inner tab-pane fade"} id="profile" role="tabpanel" aria-labelledby="profile-tab" >
                        <RequisitionSpecialisationList/>
                    </div>    
                    <div className={stepName === "RequisitionPostList" ? "tabContent-inner tab-pane fade show active" : "tabContent-inner tab-pane fade"} id="profile" role="tabpanel" aria-labelledby="profile-tab" >
                        <RequisitionPostList/>
                    </div> */}
                </div>
            </>
            : 
                <div className="premium-permission-box">
                    <h1>{commonEnLabels.COMMON.ACCESS_DENIED}</h1>
                </div>
            }
        </div>
    )
}

export default MasterManagement;


